export default __webpack_public_path__ + "static/media/marblemiddle.a6c2056a.jpg";